import './App.css';
import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
// import HomePage from './pages/Home/HomePage';
import AboutPage from './pages/About/AboutPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import SettingsPage from './pages/Settings/SettingsPage';
import PavementContextBasicPage from './pages/PavementContext/PavementContextBasicPage';
import PavementContextCustomPage from './pages/PavementContext/PavementContextCustomPage';
import ConcreteEmbodiedEmissionPage from './pages/EmbodiedEmission/ConcreteEmbodiedEmissionPage';
import AsphaltEmbodiedEmissionPage from './pages/EmbodiedEmission/AsphaltEmbodiedEmissionPage';
import PavementDesignPage from './pages/PavementDesign/PavementDesignPage';
import ReportPage from './pages/Report/ReportPage';
import ReportPageDynamic from './pages/Report/ReportPageDynamic';

import DesignSpecificationPage from './pages/DesignSpecification/DesignSpecificationPage';
import MnRSchedulePage from './pages/MnRSchedule/MnRSchedulePage';
import OptimisationAndSensitivityPage from './pages/OptimisationAndSensitivity/OptimisationAndSensitivityPage';
import PedegreeMatrixPage from './pages/PedegreeMatrix/PedegreeMatrixPage';

import AlbedoPage from './pages/Information/AlbedoPage';
import CarbonUptakePage from './pages/Information/CarbonUptakePage';
import EndOfLifePage from './pages/Information/EndOfLifePage';
import InitialEmissionPage from './pages/Information/InitialEmissionPage';
import MnRPage from './pages/Information/MnRPage';
import PVIDeflectionPage from './pages/Information/PVIDeflectionPage';
import PVIRoughnessPage from './pages/Information/PVIRoughnessPage';
import IRIAsphaltPage from './pages/Information/IRIAsphaltPage';
import IRIRigidPage from './pages/Information/IRIRigidPage';

import UserGuidePage from './pages/UserGuide/UserGuidePage';
import SignIn from './pages/Temporary/SignInPage';
import SignUp from './pages/Temporary/SignUpPage';
import ProfilePage from './pages/Profile/ProfilePage';
import NotFound404Page from './pages/Service/NotFound404Page';
import SitemapPage from './pages/Service/SitemapPage';
import CO2DetailedReportPage from './pages/Report/CO2DetailedReportPage';
import CostDetailedReportPage from './pages/Report/CostDetailedReportPage';
import DetailedReportPageDynamic from './pages/Report/DetailedReportPageDynamic';
import ComparisonPage from './pages/Report/Comparison';
import PlotlyReportPage from './pages/Report/PlotlyReportPage';
import Documentation from './components/Documentation/Documentation';

function App() {
  return (
    <>
      <Routes>
        <Route element={<Layout />} >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/user-guide" element={<UserGuidePage />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/me" element={<ProfilePage />} />

          {/* TODO: Optional ID parameters need to be removed in production code. For testing purpose only*/}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/pavement-context-basic/:id?" element={ <PavementContextBasicPage />} />
          <Route path="/pavement-context-custom/:id?" element={ <PavementContextCustomPage />} />
          <Route path="/concrete-embodied-emission/:id?" element={ <ConcreteEmbodiedEmissionPage /> } />
          <Route path="/asphalt-embodied-emission/:id?" element={ <AsphaltEmbodiedEmissionPage /> } />
          <Route path="/pavement-design/:id?" element={ <PavementDesignPage /> } />
          <Route path="/report/:id?" element={ <ReportPage /> } />
          <Route path="/report-dynamic/:id?" element={ <ReportPageDynamic /> } />
          <Route path="/detailed-report-co2/:id?" element={ <CO2DetailedReportPage /> } />
          <Route path="/detailed-report-cost/:id?" element={ <CostDetailedReportPage /> } />
          <Route path="/detailed-report-dynamic/:id?" element={ <DetailedReportPageDynamic /> } />
          <Route path="/plotly-report/:id?" element={ <PlotlyReportPage /> } />
          <Route path="/comparison" element={ <ComparisonPage /> } />

          <Route path="/design-specification" element={ <DesignSpecificationPage /> } />
          <Route path="/mnr-schedule" element={ <MnRSchedulePage /> } />
          <Route path="/optimisation-and-sensitivity" element={ <OptimisationAndSensitivityPage /> } />
          <Route path="/pedegree-matrix/:id" element={ <PedegreeMatrixPage />} />

          <Route path="/info/albedo" element={ <AlbedoPage /> } />
          <Route path="/info/carbon-uptake" element={ <CarbonUptakePage /> } />
          <Route path="/info/end-of-life" element={ <EndOfLifePage /> } />
          <Route path="/info/initial-emission" element={ <InitialEmissionPage /> } />
          <Route path="/info/mnr" element={ <MnRPage /> } />
          <Route path="/info/pvi-deflection" element={ <PVIDeflectionPage /> } />
          <Route path="/info/pvi-roughness" element={<PVIRoughnessPage />} />
          <Route path="/info/iri-asphalt" element={<IRIAsphaltPage />} />
          <Route path="/info/iri-rigid" element={<IRIRigidPage />} />

          {/** Temporary pages. For development purpose only */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="*" element={<NotFound404Page />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
